import API from './Api'

const endpointBaseUrl = 'classifiers';

class ClassifiersService {
    baseUrl(){
        return endpointBaseUrl;
    }

    getClassifiers() {
        return API.get(endpointBaseUrl);
    }

    getClassifier(name) {
        return API.get(endpointBaseUrl + '/' + name);
    }
}

export default new ClassifiersService();

